import script from "./cau-hinh-icon.vue?vue&type=script&setup=true&lang=js"
export * from "./cau-hinh-icon.vue?vue&type=script&setup=true&lang=js"

import "./cau-hinh-icon.vue?vue&type=style&index=0&id=9fb1abe8&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fb1abe8"]])

export default __exports__